// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountLevelingRestriction_wrapper"};